import React, { Component } from "react";

/*
This component returns a form for the user to enter the USD amount to be converted 
*/
export class BaseCurrency extends Component {
  render() {
    return (
      <form action="" className="form-inline mb-4">
        <div className="input-group mb-3">
          <span className="input-group-text" id="inputGroup-sizing-default">
            USD
          </span>
          <input
            className="form-control pointer"
            aria-label="Sizing example input"
            aria-describedby="inputGroup-sizing-default"
            // amount value passed through props
            value={this.props.amount}
            // handleInput function passed through props
            onChange={this.props.handleInput}
            type="number"
          />
        </div>
      </form>
    );
  }
}

export default BaseCurrency;
